var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//@ts-nocheck1
import React, { useEffect, useState } from 'react';
import { ListLayout, Datacolumn } from '@igblsln/control';
import { PAGE_SIZE, useActiveProjectQuery, useAppDispatch, setPaymentMenu, getPreviousYears, getMonthsFor, useUnitsForProjectQuery } from '@igblsln/store';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { useDeleteConstructionReceiptMutation, useListReceiveConstructionInvoiceQuery, useListConstructionReceiptQuery, useExportConstructionReceiptsQuery } from '../apis';
import CreateModal from '../Modals/CreateModal';
import ViewModal from '../Modals/ViewModal';
import { generateVoucherPDF } from '../../../utils/pdfGenerator';
import { getClientProps } from '@igblsln/store';
import { generateReceiptExcel, downloadExcelBlob } from '../../../utils/receiptExportUtils';
const Main = (props) => {
    var _a, _b, _c, _d, _e;
    const dispatch = useAppDispatch();
    const { company_name } = getClientProps();
    const years = getPreviousYears(5);
    const [selectedYear, setSelectedYear] = useState(years[0]);
    var months = getMonthsFor(selectedYear);
    const [selectedMonth, setSelectedMonth] = useState(null);
    useEffect(() => {
        months = getMonthsFor(selectedYear);
        setSelectedMonth(months[months.length - 1].value);
    }, [selectedYear]);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(PAGE_SIZE);
    const [selectedProjectKey, setSelectedProjectKey] = useState(null);
    const [displayViewModal, setDisplayViewModal] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState({});
    const [selectedReceipt, setSelectedReceipt] = useState({});
    const [showCreateDirectInvoiceModal, setShowCreateDirectInvoiceModal] = useState(false);
    const { data: allProjects } = useActiveProjectQuery();
    const selectedProject = allProjects === null || allProjects === void 0 ? void 0 : allProjects.find((p) => (p === null || p === void 0 ? void 0 : p.key) === selectedProjectKey);
    const projectTypeRaw = (_c = (_b = (_a = selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.pro_type) === null || _a === void 0 ? void 0 : _a.descr) !== null && _b !== void 0 ? _b : selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.pro_type) !== null && _c !== void 0 ? _c : "";
    const normalizedProjectType = projectTypeRaw.toString().trim().toLowerCase();
    const isVillaOrResidential = normalizedProjectType.includes("villa") || normalizedProjectType.includes("residential");
    const isUnitRequired = !isVillaOrResidential;
    const { data: allUnits } = useUnitsForProjectQuery({ projectId: selectedProjectKey }, { skip: !selectedProjectKey || !isUnitRequired, refetchOnMountOrArgChange: true });
    const canQueryByProject = !!selectedProjectKey;
    const canQueryByUnit = !!selectedProjectKey && !!selectedUnit;
    const { data: constructionReceiptsByUnit, isFetching: isConstructionReceiptByUnitLoading } = useListConstructionReceiptQuery({ page: page, size: size, project: selectedProjectKey, unit: selectedUnit }, {
        skip: !canQueryByUnit,
        refetchOnMountOrArgChange: true
    });
    const { data: constructionReceiptsByProject, isFetching: isConstructionReceiptByProjectLoading } = useListConstructionReceiptQuery({ page: page, size: size, project: selectedProjectKey, unit: null }, {
        skip: !canQueryByProject,
        refetchOnMountOrArgChange: true
    });
    const [deleteDataAction, { isLoading: isDeleting }] = useDeleteConstructionReceiptMutation();
    const deleteAction = (id) => {
        deleteDataAction(id).unwrap();
    };
    const { data: receivableInvoicesByUnit, isFetching: isReceivableByUnitLoading } = useListReceiveConstructionInvoiceQuery({ page: page, size: size, project: selectedProjectKey, unit: selectedUnit }, { skip: !canQueryByUnit });
    const { data: receivableInvoicesByProject, isFetching: isReceivableByProjectLoading } = useListReceiveConstructionInvoiceQuery({ page: page, size: size, project: selectedProjectKey, unit: null }, { skip: !canQueryByProject });
    const receivableInvoices = selectedUnit
        ? (((_d = receivableInvoicesByUnit === null || receivableInvoicesByUnit === void 0 ? void 0 : receivableInvoicesByUnit.results) === null || _d === void 0 ? void 0 : _d.length) ? receivableInvoicesByUnit : receivableInvoicesByProject)
        : receivableInvoicesByProject;
    const constructionReceipts = selectedUnit
        ? (((_e = constructionReceiptsByUnit === null || constructionReceiptsByUnit === void 0 ? void 0 : constructionReceiptsByUnit.results) === null || _e === void 0 ? void 0 : _e.length) ? constructionReceiptsByUnit : constructionReceiptsByProject)
        : constructionReceiptsByProject;
    const isLoading = isReceivableByUnitLoading || isReceivableByProjectLoading;
    const isConstructionReceiptLoading = isConstructionReceiptByUnitLoading || isConstructionReceiptByProjectLoading;
    useEffect(() => {
        dispatch(setPaymentMenu('receive'));
        return () => {
            dispatch(setPaymentMenu(''));
        };
    }, [dispatch]);
    useEffect(() => {
        var _a;
        if (allProjects) {
            setSelectedProjectKey((_a = allProjects[0]) === null || _a === void 0 ? void 0 : _a.key);
        }
    }, [allProjects]);
    useEffect(() => {
        var _a;
        if (!isUnitRequired) {
            setSelectedUnit(null);
            return;
        }
        if (allUnits === null || allUnits === void 0 ? void 0 : allUnits.length) {
            const hasCurrentUnit = allUnits === null || allUnits === void 0 ? void 0 : allUnits.some((u) => (u === null || u === void 0 ? void 0 : u.key) === selectedUnit);
            if (!hasCurrentUnit) {
                setSelectedUnit((_a = allUnits[0]) === null || _a === void 0 ? void 0 : _a.key);
            }
        }
        else {
            setSelectedUnit(null);
        }
    }, [allUnits, isUnitRequired, selectedUnit]);
    const customDiscard = () => {
        setShowCreateDirectInvoiceModal(false);
        setDisplayViewModal(false);
    };
    const { data: exportData, isLoading: isExporting } = useExportConstructionReceiptsQuery({ projectId: selectedProjectKey, unitId: selectedUnit }, { skip: !selectedProjectKey });
    const exportToExcel = () => __awaiter(void 0, void 0, void 0, function* () {
        const data = Array.isArray(exportData) ? exportData : [];
        if (!data.length)
            return;
        const projectPart = (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.name)
            ? String(selectedProject.name).trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '')
            : 'Project';
        const blob = yield generateReceiptExcel(data, projectPart, 'Construction Receipts');
        downloadExcelBlob(blob, `${projectPart}_Construction_Receipts_${new Date().toISOString().split('T')[0]}.xlsx`);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, null),
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement("div", { className: "field col-6" },
                React.createElement("label", { className: 'col-4' }, "Project Name"),
                React.createElement(Dropdown, { style: { width: '60%' }, optionLabel: "name", optionValue: "key", value: selectedProjectKey, onChange: (e) => {
                        setSelectedUnit(null);
                        setSelectedProjectKey(e.value);
                    }, filter: true, filterBy: 'name', options: allProjects, placeholder: 'Select Project' })),
            !isVillaOrResidential && (React.createElement("div", { className: "field col-6" },
                React.createElement("label", { className: 'col-4' }, "Unit Name"),
                React.createElement(Dropdown, { style: { width: '60%' }, optionLabel: "descr", optionValue: "key", value: selectedUnit, onChange: (e) => {
                        setSelectedUnit(e.value);
                    }, options: allUnits, placeholder: 'Select Unit' })))),
        React.createElement(TabView, { className: 'custom-tabview' },
            React.createElement(TabPanel, { header: "Receive Construction Invoice" },
                React.createElement("div", { className: "col-12 ", style: { height: 'calc(100% - 383px)', minHeight: 200 } },
                    React.createElement(ListLayout, { baseRoute: `/weeklypayment`, description: "Pending Payments", isLoading: isConstructionReceiptLoading, data: receivableInvoices === null || receivableInvoices === void 0 ? void 0 : receivableInvoices.results, newTable: true, showHeader: true, hideAddButton: true, tableLayoutClass: 'h-full', allowFilters: false, hideActionColumn: true },
                        React.createElement(Datacolumn, { field: "invoice_id", header: "Invoice No" }),
                        React.createElement(Datacolumn, { field: "invoice_date", header: "Invoice Date" }),
                        React.createElement(Datacolumn, { field: "customer_name", width: "20%", header: "Customer Name" }),
                        React.createElement(Datacolumn, { field: "invoice_amount", header: "Invoice Amt", type: "currency", defaultValue: 0 }),
                        React.createElement(Datacolumn, { field: "pending_amount", header: "Pending Amt", type: "currency", defaultValue: 0 }),
                        React.createElement(Datacolumn, { width: "15%", field: "makepayment", header: "Make Payment", type: "custom", displayValueGetter: (row) => React.createElement(Button, { style: { height: 30, marginRight: 10, marginBottom: 3 }, onClick: () => {
                                    setSelectedInvoice(row);
                                    setShowCreateDirectInvoiceModal(true);
                                } }, "Receive") })))),
            React.createElement(TabPanel, { header: "Construction Receipt" },
                React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end', marginBottom: 10 } },
                    React.createElement(Button, { label: "Master Export", icon: "pi pi-file-export", onClick: exportToExcel, loading: isExporting, disabled: !selectedProjectKey })),
                React.createElement("div", { className: "col-12 ", style: { height: 'calc(100% - 383px)', minHeight: 200 } },
                    React.createElement(ListLayout, { baseRoute: `/weeklypayment`, description: "Pending Payments", isLoading: isLoading, pagination: {
                            pageSize: size,
                            loading: isLoading,
                            currentPage: page,
                            total: 0,
                            onChange: (page, size) => {
                                setPage(page);
                                setSize(size);
                            }
                        }, data: constructionReceipts === null || constructionReceipts === void 0 ? void 0 : constructionReceipts.results, newTable: true, showHeader: true, hideAddButton: true, tableLayoutClass: 'h-full', allowFilters: false, hideActionColumn: true },
                        React.createElement(Datacolumn, { field: "date", header: "Receipt Date" }),
                        React.createElement(Datacolumn, { field: "receipt_number", header: "Receipt ID" }),
                        React.createElement(Datacolumn, { field: "customer_name", header: "Customer Name" }),
                        React.createElement(Datacolumn, { field: "amount", header: "Amount" }),
                        React.createElement(Datacolumn, { field: "payment_mode", header: "Payment Mode" }),
                        React.createElement(Datacolumn, { field: "notes", header: "Notes" }),
                        React.createElement(Datacolumn, { width: "10%", field: "view", header: "View", type: "custom", displayValueGetter: (row) => React.createElement(Button, { style: { height: 30, marginRight: 10, marginBottom: 3 }, onClick: () => {
                                    setSelectedReceipt(row);
                                    setDisplayViewModal(true);
                                } }, "View") }),
                        React.createElement(Datacolumn, { width: "10%", field: "export", header: "Export", type: "custom", displayValueGetter: (row) => React.createElement(Button, { style: { height: 30, marginRight: 10, marginBottom: 3 }, onClick: () => generateVoucherPDF(row, '/payment/constructionreceipt', { name: company_name }) }, "Export") }),
                        React.createElement(Datacolumn, { field: "delete", header: "Delete", type: "custom", width: "10%", displayValueGetter: (row) => React.createElement(Button, { style: { height: 30, marginRight: 10, marginBottom: 3 }, onClick: () => confirmDialog({
                                    message: 'Are you sure to delete?',
                                    header: 'Confirmation',
                                    icon: 'pi pi-exclamation-triangle',
                                    accept: () => deleteAction(row.key),
                                    reject: () => { }
                                }) }, "Delete") }))))),
        showCreateDirectInvoiceModal &&
            React.createElement(CreateModal, { displayModal: showCreateDirectInvoiceModal, customDiscard: customDiscard, invoiceData: selectedInvoice }),
        displayViewModal &&
            React.createElement(ViewModal, { data: selectedReceipt, displayModal: displayViewModal, customDiscard: customDiscard })));
};
export default Main;
